module.exports = __webpack_public_path__ + "img/PLUS.ab322b46.svg";